import { Schema } from 'mongoose';
import localizedTextSchema, { ILocalizedText } from './localized-text';
import { IImageSizeTypes, imageSizeTypes } from './media-files';

export interface IMedia {
  type: string;
  hero: boolean;
  names: ILocalizedText;
  files: IImageSizeTypes;
}
const media = new Schema(
  {
    type: {
      type: String,
      required: true,
      enum: ['image'],
    },
    hero: {
      type: Boolean,
      required: true,
    },
    names: {
      type: localizedTextSchema,
      required: true,
    },
    files: {
      type: imageSizeTypes,
      required: true,
    },
  },
  { _id: false },
);

export default media;
